
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexXcbQfOwh1cQzwAOz3_NjLC0w3uWBfjVFs2M7qzyQNmIMeta } from "/builds/on-that-ass/Frontend/app/pages/index.vue?macro=true";
import { default as _404qmDatsjZ9Gjy_XPAVZgGKmP5CBSiTl2QWsgeoLeX96gMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/404.vue?macro=true";
import { default as indexAWb3FpJRItBCv_6q69YyJKUnx3ylyazE2KsMD5ZPRboMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/index.vue?macro=true";
import { default as loginbonc_bzj12hLS8MkUJr28Phec5pDi2CkQjARa2_CTbkMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/login.vue?macro=true";
import { default as indexhkon6psCZPMXZbXGEm_tXtG1gX1kTHRt7nWUdbP1nocMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/men/index.vue?macro=true";
import { default as indexwYh_hdRjAdcnrSPc5Ydp2BIam4lSaTlD0VgRU3txURIMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/index.vue?macro=true";
import { default as indexxQ_NHjjBc_T47lSZLfleTrSoqOcEfOmMD0ZTIWWLEgMMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/signup/index.vue?macro=true";
import { default as indexev93k_11HHHq8wtEN2_bgF6jiXLCCdcbBE82NUbSrQ0Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/index.vue?macro=true";
import { default as indexULUPpPhruT5w8mxG8lhUueJebKEtZNfJj7wjseKC8uMMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/contact/index.vue?macro=true";
import { default as indexa4y_kf7shKNXH8Z6BeYt_FJ_6ihBsSBIW9LhjKpgOB8Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/imprint/index.vue?macro=true";
import { default as indexHMk6z59zVcond3LA9dsQHIfuz_hK9LvpXiEQI1Khni0Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/loyalty/index.vue?macro=true";
import { default as indexd3PUptJFY72uz4h_h9fvvAjNHtvbferyqaDv3ChYd5AMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/try-now/index.vue?macro=true";
import { default as indexwgB4W6yzh5ox4Yazbpik9bjcZ8iyyvR0km_P5erCZAkMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/webshop/index.vue?macro=true";
import { default as indexlwxN4gmbOfbBp_51lfwjrooRew6_sRTxtfmZvFYeYn4Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/about-us/index.vue?macro=true";
import { default as indexX2ItOyaSx41sQmfzOAFp9T1Q1FPmc6BsHZTi30MSx0cMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/comeback/index.vue?macro=true";
import { default as add_45undershirtstfEhyz3nCoF1TBBwpSLQAnpHXhw9Ofv606qO_JCmd2UMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/add-undershirts.vue?macro=true";
import { default as index45np4iRldZ54Ut7fyjMUuTluuUaSGhg5uQAveZ5XgYQMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/affiliate/index.vue?macro=true";
import { default as indexcM5KRBSU5e8nDYPgHGOqYr7IF1J6kMxfMveUhXJUQuYMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/index.vue?macro=true";
import { default as indexald_OzT2iBPSzkttmbtSN6FCTVr6eGIZEunzSvrUlA0Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/reactivate/index.vue?macro=true";
import { default as add_45socks_45regular4OlJ7LmXdR6BH4IiigS2u5gTwCS18Jt0rd0yTEr6UkMMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/add-socks-regular.vue?macro=true";
import { default as index6eSLjPh5V_Bp8h3RPGfWI0fUzUGEZom5Ovr1qiIGQzYMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/terms-of-use/index.vue?macro=true";
import { default as indexGR1hn86aILvfmxH_WdKJX2vlFIvkQ6KrztlVGiGNj3cMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/index.vue?macro=true";
import { default as indexPUnHoe8C_wCzQ6Bbu_YNfs6VgcUDEJlrz6265dwwAjEMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/eauta-for-men/index.vue?macro=true";
import { default as sold_45outtROfOOj7DO_MZMOw21X4SvBqVckv5Hku4ti4miyOekwMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/sold-out.vue?macro=true";
import { default as indexQUzts88uAKTmRD_4JD8Q2yWf0_YsrxTW092ipj8RPj0Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/reactivate-30/index.vue?macro=true";
import { default as indexJH4lMWCQGNXHxIZ553baSXz4GNPsxBLmnq2JKNP3GDwMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/reactivate-40/index.vue?macro=true";
import { default as index932fpQZ0NHvSsYOFzaTDtm4Qdu0Z0EBRMKi25ZhETssMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/product/index.vue?macro=true";
import { default as indexNV5frMQ_hT6rLRGWzCOkdcuYdiF3criSdhagBrqajEkMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/orders/index.vue?macro=true";
import { default as sizechartB_c0Wv8pU__7NqEefNmzReGa9_XAiq8K6pPqpCTGQecMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/sizechart.vue?macro=true";
import { default as indexgobaxyC93ARxJWDFmyIulmOE_HnnsDX8iVDYkEeV73AMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/password-reset/index.vue?macro=true";
import { default as indexk512JTQw7kFt7n9Jki73uNxwK_eR9CPaSCE8SPgxFZwMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/reactivate-new/index.vue?macro=true";
import { default as indexaJYrEjq41I8dkDX0FKng6iK5Qsx3bpboJ8s56BeLQEUMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/refer-a-friend/index.vue?macro=true";
import { default as indexBOESPm0j8256hD6_rEU9ENvXpHrEjZaJkv0CbqlcKzcMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/sustainability/index.vue?macro=true";
import { default as indexlJNlYWK6JXb7HQWUbq0iTCF5iuEWkKTh1hyLmTiWSJwMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/bra-size/index.vue?macro=true";
import { default as indexEmiReFo_hwB5h8jZ6mW1vEbi5Y_mmrLKKojqy3uYrX4Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/comeback/index.vue?macro=true";
import { default as indexzWBXEGVO2kT_CGzOmWMDQpPVRWnuf_TxDPETR0l20pMMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/customer-service/index.vue?macro=true";
import { default as indexJZETsrYpMRlYbj4daEbRYicOqyjNdaPxr7DuWg3j2y8Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/socks/reactivate/index.vue?macro=true";
import { default as indextw25oWf6X5cFzp9misuKf46u70mgYMjs2MZVxCKl_8sMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/reactivate/index.vue?macro=true";
import { default as addI2qpSQc7RJa6EfDV5QU8VXx9FqZo_RKbIXG_2yoPtMQMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/add.vue?macro=true";
import { default as pay_NHYXwLRsh3yHoEvY1RRSlAwzP3USWlLXPqwkqIH3U8Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/orders/[id]/pay.vue?macro=true";
import { default as indexC_zLKsoNDfVEqxqYaDE8Uv4yOvYO7U7NGSC5cjjzdoAMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/cancel-membership/index.vue?macro=true";
import { default as indexibvoL_DGvuHrvOoAnvqqNcI_3XLh1KmcEyKmiOIjNggMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/privacy-statement/index.vue?macro=true";
import { default as indexVfOtDpPyehfRD88tznaI3fYERuu3aNk_85DsT76jIVkMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/[specialDesignUrl]/index.vue?macro=true";
import { default as indexPP77YaP9e_nSFC5wWbrInHdqKqorGXnccRg0AjdKuKoMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/cookie-declaration/index.vue?macro=true";
import { default as indexRgXG0BeCvgahHKAoYW_lvgFOlWkOAG7z8cPRhRUr7c4Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/referred-by-friend/index.vue?macro=true";
import { default as indexZlZt1qMX7YkSGwWpMIeg0tz9G9nSJR6iUuA455w2kFcMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/index.vue?macro=true";
import { default as indexnj4rFoiHcGQLEwXYyEcpr9VYqT7kxpf8u52JSixUZL4Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/orders/[id]/index.vue?macro=true";
import { default as indexA_p4HQS_YEMDUnfGhc_YLBQd2wPOwprundplpF_5ds0Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/explore-memberships/index.vue?macro=true";
import { default as indexNGY7eAiBG9f_rNALgywPVtGqZTlNSqM79jlYV9Gv9F4Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/right-of-withdrawal/index.vue?macro=true";
import { default as _91slug_93ieyifUEhrVK8Ge7eb8ZH29IVh3TFmhexzrNOiVes_woMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/webshop/[category]/[slug].vue?macro=true";
import { default as indexi8utJfczoW2n89glVx_eCf43JEihD_EKtMny2q3o_tEMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/data-request-success/index.vue?macro=true";
import { default as indexirTeiwSE3rD6nrn4kbOHBgOKtzAONGNpKP_6o9rJW1gMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/men/customer-service/index.vue?macro=true";
import { default as indexZ7TUNFw1x9ObclJ9NKbdUZmpPWz_4Acug71vjZIN9C0Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/terms-and-conditions/index.vue?macro=true";
import { default as indexse8rM_Q5dydi5cPRVfxaK1gjY_Os5Bk3CIE5ZXKehIIMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/signup/create-account/index.vue?macro=true";
import { default as indexBO8bK_fNMSek3NxpVOSGbPm7jdfGhl2R_oIGPXqvEcYMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/delete-request-success/index.vue?macro=true";
import { default as indexiriEnag4EPVm0mPFbwwigKNBtMQ3uN5QXmzQrmd7XiAMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/lookbook/[orientation]/index.vue?macro=true";
import { default as indexGejcCKJV3CFL_mvpoZYEgx_NIOlQbp_pGKjE0iF0_4cMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/password-reset/[token]/index.vue?macro=true";
import { default as indexqJ8dBwlwlGR_rCsQv4Y_WQxZ_4wtgBeTXjeAG2sA4BEMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/undershirts/reactivate/index.vue?macro=true";
import { default as indexKK52USaJ3ZykgdWhUVaaHDviJTybrWbHIHdfAwzvig8Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/customer-service/index.vue?macro=true";
import { default as indexeQgI7bDGPu1GZynKj9Ptv0K490JpqghEA8WHNifnwAEMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/loyalty-program/index.vue?macro=true";
import { default as _91slug_93cLnXt2027_n6m__pbDId3LKeWfzUUfDSM__V_3nkQwMMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/lookbook/[orientation]/[slug].vue?macro=true";
import { default as paidmjXI1YT01PQFxr_o7Cz65VkijXbpofTzcgyJlxRYK20Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/open-payment/[paymentId]/paid.vue?macro=true";
import { default as indexe2cZ8kHbKoPpiJsYzvVGxgZtqoEzW_sU9xU2bixQiAoMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/[id]/index.vue?macro=true";
import { default as indexZw0Bp_ee_7siiN4Atws8zLk2SmQYsWvexeriIWOQ_gEMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/index.vue?macro=true";
import { default as indexhT0JW5hUCCUazWHMwzlSPa0PXjPbWlOpm7VA43BHxBUMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/choose-design/index.vue?macro=true";
import { default as indexEmIoW1UszmEzOTRWS_s3y5w5kzen496SEucMloLae44Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/open-payment/[paymentId]/index.vue?macro=true";
import { default as indexDPLwlK_0wpxkdr44__DGaA6jLUNBedVVxznZQ7WX384Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/transaction-confirmation/index.vue?macro=true";
import { default as index_McjWG0Xa2FlkjUvAaW_VNVNdREtc70MMCbK2UHDclsMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/webshop/checkout/payment/index.vue?macro=true";
import { default as indexXYR_P1GjsOOTel4ypjJydtZJWee01wcZYbUGx1FAyQEMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/create-account/index.vue?macro=true";
import { default as indexUZ4JmQJF5zMmZBpc3QyElnX2ugnnP2ywiV5_dMyv7PUMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/webshop/checkout/shipping/index.vue?macro=true";
import { default as detailsH86G2AUup_04KDTxyP1ph6P8DHFJ5JG6c_p_hQV4XgEMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/[id]/details.vue?macro=true";
import { default as pendingKOcJNrJFHpeQc9RgH1vWVyUXBC5y9BNgo69GhyQLrqIMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/open-payment/[paymentId]/pending.vue?macro=true";
import { default as successAHblvuhJKQ9j0XqcNcmy7wrJeXSB_nCueaT9Ki60A4YMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/open-payment/[paymentId]/success.vue?macro=true";
import { default as indexu9d4AeaWSfUuK_E2FKmMGY3ZYEWAP7zxS5AWhd2zULEMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/choose-design/index.vue?macro=true";
import { default as passwordxPbinONiHIKbBS_t2OrOpJJjIahabqxjwklGA6bqCngMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/password.vue?macro=true";
import { default as indexRNlP1DaQ6yiBxHPYoh0U3eHLQNpENZ5SmAr_YfSEH20Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/create-account/index.vue?macro=true";
import { default as index_idubwgSKXA2HsNOemsnT5k68hShmaoGvGXljsNCm0IMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/men/customer-service/[topic]/index.vue?macro=true";
import { default as ad_45detailsg1W1MlBt2UYs3_emcQfoHdZb8jEa_W39Eh6xP_bcWz8Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/[id]/ad-details.vue?macro=true";
import { default as indexuMu3I35nlEHV03FJpCybAbLL_YEmSuKAc8gvdPGMRrMMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/customer-service/pause-cancel/index.vue?macro=true";
import { default as reactivatedAFgkfwEysBqP3D01qV76rcs2kZih__2YFL34PaEUDAwMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/[id]/reactivated.vue?macro=true";
import { default as _91orderId_937wCLe3U7XaafK1bY_dyTZm0O4w2cFBDYnQXrZh5Q_pgMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/orders/[id]/return/[orderId].vue?macro=true";
import { default as indexkUgz6udFG66O1una4_DFYc9Fyqg9PUT3CB9A58MJKW4Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/delete-request-deleted-success/index.vue?macro=true";
import { default as indexcKbqfnGnXRcNRtkd9TL8Pu5kO6H2UjArqYL2n0k8V1UMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/customer-service/[topic]/index.vue?macro=true";
import { default as boxer_45shorts1pbCuqaUCyQg8E5gtukSsCcOZHbEnGuXd3Ipe7qNCt4Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/[id]/boxer-shorts.vue?macro=true";
import { default as contact_45infoSA6KHwNhJl6DnWh2_Eb_hTOM2TBAiyJW27xh_x0fsEkMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/contact-info.vue?macro=true";
import { default as personal_45infowulrEwvsWTlLRIamgpiVTj5pt50lpzIGM1dk4yBzn1oMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/personal-info.vue?macro=true";
import { default as indexUyBGseySDPH8aqOPNNi6Lz4fCbfZrjQm_nd1ncpDhegMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/request-personal-details/index.vue?macro=true";
import { default as indexhrP_Cw_7MelHr30xD8H0CZexWSSZXfo8KhBlmohoCBwMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/security/index.vue?macro=true";
import { default as indexGT1n3hoEqbGU6THHl_aYBm_JLRlxJ_jF_xQyPcisb3AMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/[bralette]/[hipster]/index.vue?macro=true";
import { default as payment_45detailsb78brCaBhFJTIS_iHukwaRqBEOUwOiC5lxiX7mWEytoMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/payment-details.vue?macro=true";
import { default as indexRq0oZ_fHIZbmcizLeoi_n5SnTV1O2XQXfiTQRFvNlKcMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/overview/member/index.vue?macro=true";
import { default as indexftJqd6l4KQI72qfORW_nfvv2y65Mm4szO8d1Br_nEpQMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/overview/status/index.vue?macro=true";
import { default as indexPWqCIOHFamLMKVbgeb_aNbk9go4NLpbPxdPVb9noZpsMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/overview/address/index.vue?macro=true";
import { default as indexn01V1rGZBBQv_czTrLONLBiA4rAG8WEIv_a8PaLV_aoMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/[membershipType]/[design]/index.vue?macro=true";
import { default as indexA0ml4b8wt6XaYPdAUch7S3IOfZEN5cl_ArLVDc6QjQoMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/webshop/checkout/payment/confirmation/index.vue?macro=true";
import { default as index0agOwDzfMf73y0Ud9JL6JSPCv89f3rhw3XVe_EDtmZ8Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/overview/boxershorts/index.vue?macro=true";
import { default as indexww70SSxYl__cn0V9_kfKhcUkKSJAMyVie4Sp_3jKyn0Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/[id]/cancel-membership/index.vue?macro=true";
import { default as indexrDeMNONq2wnXuIMFx8L9EEWUhIRYPYAWnguUwrqmOdoMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/explore-memberships/[membershipTypeReference]/index.vue?macro=true";
import { default as indexkQTpXs9Rm9YzaPLk1SLQfegyBsU64sIZQWDXOZ6Iyb8Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/security/data-request/index.vue?macro=true";
import { default as indexnz9zHLNAZUCJz9eFMyQxzeLaUcf352Z7u1CVjwvQYDkMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/create-account/verification-payment/index.vue?macro=true";
import { default as indexyktmVsfpgOREbjw9BnrrkYH99ARUw5aLQiKV81h9LZsMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/create-account/verification-payment/index.vue?macro=true";
import { default as failed3dKO_RhJJUps78txNOOsYIS_MSw_FWX_RFqkKfiHl7oMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/create-account/verification-payment/failed.vue?macro=true";
import { default as index__AVWi4NOCyIl_BfGw2RJnPDvzlC4Qk0AAcV16j1ss4Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/security/deletion-request/index.vue?macro=true";
import { default as pendingLnxREaFTXh3i0357t3dOx8UuLjG47Kn8uipGaafEjAEMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/create-account/verification-payment/pending.vue?macro=true";
import { default as successbjzQBOYo2bFHTSQow_nHMtaJfCR5BH5wtURAbHLCmEAMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/create-account/verification-payment/success.vue?macro=true";
import { default as declined_dmH2_Zy75HsyvUtoJzWeOQYgJljhvNFSCZ_fJzvYjwMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/create-account/verification-payment/declined.vue?macro=true";
import { default as indexKs0vhX44ExyNItnh4NYCh2Qq8r0k5GBzc_XEv8Q_NU8Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/create-account/verification-payment/failed/index.vue?macro=true";
import { default as indexH6uYE5iYV_mULgQpJduPuiypauO0_ScTDoRNwp26P_YMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/create-account/verification-payment/pending/index.vue?macro=true";
import { default as index9eI_JdZVCXgzkp81VtznMQ8zGq8T1Fw1mH_hAgnFiS4Meta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/create-account/verification-payment/success/index.vue?macro=true";
import { default as indexW9jY765KYpwodyp9hBRCUCvCYBUGnYuwQvP3bprQ4fYMeta } from "/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/create-account/verification-payment/declined/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/builds/on-that-ass/Frontend/app/pages/index.vue")
  },
  {
    name: "lang-404",
    path: "/:lang()/404",
    meta: _404qmDatsjZ9Gjy_XPAVZgGKmP5CBSiTl2QWsgeoLeX96gMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/404.vue")
  },
  {
    name: "lang",
    path: "/:lang()",
    meta: indexAWb3FpJRItBCv_6q69YyJKUnx3ylyazE2KsMD5ZPRboMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/index.vue")
  },
  {
    name: "lang-login",
    path: "/:lang()/login",
    meta: {"middleware":["login"]},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/login.vue")
  },
  {
    name: "lang-men",
    path: "/:lang()/men",
    meta: { ...(indexhkon6psCZPMXZbXGEm_tXtG1gX1kTHRt7nWUdbP1nocMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/men/index.vue")
  },
  {
    name: "lang-women",
    path: "/:lang()/women",
    meta: { ...(indexwYh_hdRjAdcnrSPc5Ydp2BIam4lSaTlD0VgRU3txURIMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/index.vue")
  },
  {
    name: "lang-signup",
    path: "/:lang()/signup",
    meta: indexxQ_NHjjBc_T47lSZLfleTrSoqOcEfOmMD0ZTIWWLEgMMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/signup/index.vue")
  },
  {
    name: "lang-account",
    path: "/:lang()/account",
    meta: { ...(indexev93k_11HHHq8wtEN2_bgF6jiXLCCdcbBE82NUbSrQ0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/index.vue")
  },
  {
    name: "lang-contact",
    path: "/:lang()/contact",
    meta: { ...(indexULUPpPhruT5w8mxG8lhUueJebKEtZNfJj7wjseKC8uMMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/contact/index.vue")
  },
  {
    name: "lang-imprint",
    path: "/:lang()/imprint",
    meta: { ...(indexa4y_kf7shKNXH8Z6BeYt_FJ_6ihBsSBIW9LhjKpgOB8Meta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/imprint/index.vue")
  },
  {
    name: "lang-loyalty",
    path: "/:lang()/loyalty",
    meta: { ...(indexHMk6z59zVcond3LA9dsQHIfuz_hK9LvpXiEQI1Khni0Meta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/loyalty/index.vue")
  },
  {
    name: "lang-try-now",
    path: "/:lang()/try-now",
    meta: { ...(indexd3PUptJFY72uz4h_h9fvvAjNHtvbferyqaDv3ChYd5AMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/try-now/index.vue")
  },
  {
    name: "lang-webshop",
    path: "/:lang()/webshop",
    meta: { ...(indexwgB4W6yzh5ox4Yazbpik9bjcZ8iyyvR0km_P5erCZAkMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/webshop/index.vue")
  },
  {
    name: "lang-about-us",
    path: "/:lang()/about-us",
    meta: { ...(indexlwxN4gmbOfbBp_51lfwjrooRew6_sRTxtfmZvFYeYn4Meta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/about-us/index.vue")
  },
  {
    name: "lang-comeback",
    path: "/:lang()/comeback",
    meta: { ...(indexX2ItOyaSx41sQmfzOAFp9T1Q1FPmc6BsHZTi30MSx0cMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/comeback/index.vue")
  },
  {
    name: "lang-add-undershirts",
    path: "/:lang()/add-undershirts",
    meta: { ...(add_45undershirtstfEhyz3nCoF1TBBwpSLQAnpHXhw9Ofv606qO_JCmd2UMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/add-undershirts.vue")
  },
  {
    name: "lang-affiliate",
    path: "/:lang()/affiliate",
    meta: index45np4iRldZ54Ut7fyjMUuTluuUaSGhg5uQAveZ5XgYQMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/affiliate/index.vue")
  },
  {
    name: "lang-men-signup",
    path: "/:lang()/men/signup",
    meta: indexcM5KRBSU5e8nDYPgHGOqYr7IF1J6kMxfMveUhXJUQuYMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/index.vue")
  },
  {
    name: "lang-reactivate",
    path: "/:lang()/reactivate",
    meta: { ...(indexald_OzT2iBPSzkttmbtSN6FCTVr6eGIZEunzSvrUlA0Meta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/reactivate/index.vue")
  },
  {
    name: "lang-add-socks-regular",
    path: "/:lang()/add-socks-regular",
    meta: { ...(add_45socks_45regular4OlJ7LmXdR6BH4IiigS2u5gTwCS18Jt0rd0yTEr6UkMMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/add-socks-regular.vue")
  },
  {
    name: "lang-terms-of-use",
    path: "/:lang()/terms-of-use",
    meta: { ...(index6eSLjPh5V_Bp8h3RPGfWI0fUzUGEZom5Ovr1qiIGQzYMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/terms-of-use/index.vue")
  },
  {
    name: "lang-women-signup",
    path: "/:lang()/women/signup",
    meta: indexGR1hn86aILvfmxH_WdKJX2vlFIvkQ6KrztlVGiGNj3cMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/index.vue")
  },
  {
    name: "lang-eauta-for-men",
    path: "/:lang()/eauta-for-men",
    meta: indexPUnHoe8C_wCzQ6Bbu_YNfs6VgcUDEJlrz6265dwwAjEMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/eauta-for-men/index.vue")
  },
  {
    name: "lang-men-signup-sold-out",
    path: "/:lang()/men/signup/sold-out",
    meta: sold_45outtROfOOj7DO_MZMOw21X4SvBqVckv5Hku4ti4miyOekwMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/sold-out.vue")
  },
  {
    name: "lang-reactivate-30",
    path: "/:lang()/reactivate-30",
    meta: indexQUzts88uAKTmRD_4JD8Q2yWf0_YsrxTW092ipj8RPj0Meta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/reactivate-30/index.vue")
  },
  {
    name: "lang-reactivate-40",
    path: "/:lang()/reactivate-40",
    meta: indexJH4lMWCQGNXHxIZ553baSXz4GNPsxBLmnq2JKNP3GDwMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/reactivate-40/index.vue")
  },
  {
    name: "lang-women-product",
    path: "/:lang()/women/product",
    meta: { ...(index932fpQZ0NHvSsYOFzaTDtm4Qdu0Z0EBRMKi25ZhETssMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/product/index.vue")
  },
  {
    name: "lang-account-orders",
    path: "/:lang()/account/orders",
    meta: { ...(indexNV5frMQ_hT6rLRGWzCOkdcuYdiF3criSdhagBrqajEkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/orders/index.vue")
  },
  {
    name: "lang-men-signup-sizechart",
    path: "/:lang()/men/signup/sizechart",
    meta: sizechartB_c0Wv8pU__7NqEefNmzReGa9_XAiq8K6pPqpCTGQecMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/sizechart.vue")
  },
  {
    name: "lang-password-reset",
    path: "/:lang()/password-reset",
    meta: indexgobaxyC93ARxJWDFmyIulmOE_HnnsDX8iVDYkEeV73AMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/password-reset/index.vue")
  },
  {
    name: "lang-reactivate-new",
    path: "/:lang()/reactivate-new",
    meta: { ...(indexk512JTQw7kFt7n9Jki73uNxwK_eR9CPaSCE8SPgxFZwMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/reactivate-new/index.vue")
  },
  {
    name: "lang-refer-a-friend",
    path: "/:lang()/refer-a-friend",
    meta: { ...(indexaJYrEjq41I8dkDX0FKng6iK5Qsx3bpboJ8s56BeLQEUMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/refer-a-friend/index.vue")
  },
  {
    name: "lang-sustainability",
    path: "/:lang()/sustainability",
    meta: { ...(indexBOESPm0j8256hD6_rEU9ENvXpHrEjZaJkv0CbqlcKzcMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/sustainability/index.vue")
  },
  {
    name: "lang-women-bra-size",
    path: "/:lang()/women/bra-size",
    meta: { ...(indexlJNlYWK6JXb7HQWUbq0iTCF5iuEWkKTh1hyLmTiWSJwMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/bra-size/index.vue")
  },
  {
    name: "lang-women-comeback",
    path: "/:lang()/women/comeback",
    meta: { ...(indexEmiReFo_hwB5h8jZ6mW1vEbi5Y_mmrLKKojqy3uYrX4Meta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/comeback/index.vue")
  },
  {
    name: "lang-customer-service",
    path: "/:lang()/customer-service",
    meta: indexzWBXEGVO2kT_CGzOmWMDQpPVRWnuf_TxDPETR0l20pMMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/customer-service/index.vue")
  },
  {
    name: "lang-socks-reactivate",
    path: "/:lang()/socks/reactivate",
    meta: { ...(indexJZETsrYpMRlYbj4daEbRYicOqyjNdaPxr7DuWg3j2y8Meta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/socks/reactivate/index.vue")
  },
  {
    name: "lang-women-reactivate",
    path: "/:lang()/women/reactivate",
    meta: { ...(indextw25oWf6X5cFzp9misuKf46u70mgYMjs2MZVxCKl_8sMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/reactivate/index.vue")
  },
  {
    name: "lang-account-memberships-add",
    path: "/:lang()/account/memberships/add",
    meta: { ...(addI2qpSQc7RJa6EfDV5QU8VXx9FqZo_RKbIXG_2yoPtMQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/add.vue")
  },
  {
    name: "lang-account-orders-id-pay",
    path: "/:lang()/account/orders/:id()/pay",
    meta: { ...(pay_NHYXwLRsh3yHoEvY1RRSlAwzP3USWlLXPqwkqIH3U8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/orders/[id]/pay.vue")
  },
  {
    name: "lang-cancel-membership",
    path: "/:lang()/cancel-membership",
    meta: indexC_zLKsoNDfVEqxqYaDE8Uv4yOvYO7U7NGSC5cjjzdoAMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/cancel-membership/index.vue")
  },
  {
    name: "lang-privacy-statement",
    path: "/:lang()/privacy-statement",
    meta: { ...(indexibvoL_DGvuHrvOoAnvqqNcI_3XLh1KmcEyKmiOIjNggMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/privacy-statement/index.vue")
  },
  {
    name: "lang-specialDesignUrl",
    path: "/:lang()/:specialDesignUrl()",
    meta: {"middleware":["special-design"]},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/[specialDesignUrl]/index.vue")
  },
  {
    name: "lang-cookie-declaration",
    path: "/:lang()/cookie-declaration",
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/cookie-declaration/index.vue")
  },
  {
    name: "lang-referred-by-friend",
    path: "/:lang()/referred-by-friend",
    meta: { ...(indexRgXG0BeCvgahHKAoYW_lvgFOlWkOAG7z8cPRhRUr7c4Meta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/referred-by-friend/index.vue")
  },
  {
    name: "lang-account-memberships",
    path: "/:lang()/account/memberships",
    meta: { ...(indexZlZt1qMX7YkSGwWpMIeg0tz9G9nSJR6iUuA455w2kFcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/index.vue")
  },
  {
    name: "lang-account-orders-id",
    path: "/:lang()/account/orders/:id()",
    meta: { ...(indexnj4rFoiHcGQLEwXYyEcpr9VYqT7kxpf8u52JSixUZL4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/orders/[id]/index.vue")
  },
  {
    name: "lang-explore-memberships",
    path: "/:lang()/explore-memberships",
    meta: { ...(indexA_p4HQS_YEMDUnfGhc_YLBQd2wPOwprundplpF_5ds0Meta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/explore-memberships/index.vue")
  },
  {
    name: "lang-right-of-withdrawal",
    path: "/:lang()/right-of-withdrawal",
    meta: { ...(indexNGY7eAiBG9f_rNALgywPVtGqZTlNSqM79jlYV9Gv9F4Meta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/right-of-withdrawal/index.vue")
  },
  {
    name: "lang-webshop-category-slug",
    path: "/:lang()/webshop/:category()/:slug()",
    meta: { ...(_91slug_93ieyifUEhrVK8Ge7eb8ZH29IVh3TFmhexzrNOiVes_woMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/webshop/[category]/[slug].vue")
  },
  {
    name: "lang-data-request-success",
    path: "/:lang()/data-request-success",
    meta: indexi8utJfczoW2n89glVx_eCf43JEihD_EKtMny2q3o_tEMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/data-request-success/index.vue")
  },
  {
    name: "lang-men-customer-service",
    path: "/:lang()/men/customer-service",
    meta: { ...(indexirTeiwSE3rD6nrn4kbOHBgOKtzAONGNpKP_6o9rJW1gMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/men/customer-service/index.vue")
  },
  {
    name: "lang-terms-and-conditions",
    path: "/:lang()/terms-and-conditions",
    meta: { ...(indexZ7TUNFw1x9ObclJ9NKbdUZmpPWz_4Acug71vjZIN9C0Meta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/terms-and-conditions/index.vue")
  },
  {
    name: "lang-signup-create-account",
    path: "/:lang()/signup/create-account",
    meta: indexse8rM_Q5dydi5cPRVfxaK1gjY_Os5Bk3CIE5ZXKehIIMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/signup/create-account/index.vue")
  },
  {
    name: "lang-delete-request-success",
    path: "/:lang()/delete-request-success",
    meta: indexBO8bK_fNMSek3NxpVOSGbPm7jdfGhl2R_oIGPXqvEcYMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/delete-request-success/index.vue")
  },
  {
    name: "lang-lookbook-orientation",
    path: "/:lang()/lookbook/:orientation()",
    meta: { ...(indexiriEnag4EPVm0mPFbwwigKNBtMQ3uN5QXmzQrmd7XiAMeta || {}), ...{"middleware":["homepage","landing"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/lookbook/[orientation]/index.vue")
  },
  {
    name: "lang-password-reset-token",
    path: "/:lang()/password-reset/:token()",
    meta: indexGejcCKJV3CFL_mvpoZYEgx_NIOlQbp_pGKjE0iF0_4cMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/password-reset/[token]/index.vue")
  },
  {
    name: "lang-undershirts-reactivate",
    path: "/:lang()/undershirts/reactivate",
    meta: { ...(indexqJ8dBwlwlGR_rCsQv4Y_WQxZ_4wtgBeTXjeAG2sA4BEMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/undershirts/reactivate/index.vue")
  },
  {
    name: "lang-women-customer-service",
    path: "/:lang()/women/customer-service",
    meta: indexKK52USaJ3ZykgdWhUVaaHDviJTybrWbHIHdfAwzvig8Meta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/customer-service/index.vue")
  },
  {
    name: "lang-account-loyalty-program",
    path: "/:lang()/account/loyalty-program",
    meta: { ...(indexeQgI7bDGPu1GZynKj9Ptv0K490JpqghEA8WHNifnwAEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/loyalty-program/index.vue")
  },
  {
    name: "lang-lookbook-orientation-slug",
    path: "/:lang()/lookbook/:orientation()/:slug()",
    meta: { ...(_91slug_93cLnXt2027_n6m__pbDId3LKeWfzUUfDSM__V_3nkQwMMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/lookbook/[orientation]/[slug].vue")
  },
  {
    name: "lang-open-payment-paymentId-paid",
    path: "/:lang()/open-payment/:paymentId()/paid",
    meta: paidmjXI1YT01PQFxr_o7Cz65VkijXbpofTzcgyJlxRYK20Meta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/open-payment/[paymentId]/paid.vue")
  },
  {
    name: "lang-account-memberships-id",
    path: "/:lang()/account/memberships/:id()",
    meta: indexe2cZ8kHbKoPpiJsYzvVGxgZtqoEzW_sU9xU2bixQiAoMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/[id]/index.vue")
  },
  {
    name: "lang-account-personal-details",
    path: "/:lang()/account/personal-details",
    meta: { ...(indexZw0Bp_ee_7siiN4Atws8zLk2SmQYsWvexeriIWOQ_gEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/index.vue")
  },
  {
    name: "lang-men-signup-choose-design",
    path: "/:lang()/men/signup/choose-design",
    meta: indexhT0JW5hUCCUazWHMwzlSPa0PXjPbWlOpm7VA43BHxBUMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/choose-design/index.vue")
  },
  {
    name: "lang-open-payment-paymentId",
    path: "/:lang()/open-payment/:paymentId()",
    meta: indexEmIoW1UszmEzOTRWS_s3y5w5kzen496SEucMloLae44Meta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/open-payment/[paymentId]/index.vue")
  },
  {
    name: "lang-transaction-confirmation",
    path: "/:lang()/transaction-confirmation",
    meta: indexDPLwlK_0wpxkdr44__DGaA6jLUNBedVVxznZQ7WX384Meta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/transaction-confirmation/index.vue")
  },
  {
    name: "lang-webshop-checkout-payment",
    path: "/:lang()/webshop/checkout/payment",
    meta: { ...(index_McjWG0Xa2FlkjUvAaW_VNVNdREtc70MMCbK2UHDclsMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/webshop/checkout/payment/index.vue")
  },
  {
    name: "lang-men-signup-create-account",
    path: "/:lang()/men/signup/create-account",
    meta: indexXYR_P1GjsOOTel4ypjJydtZJWee01wcZYbUGx1FAyQEMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/create-account/index.vue")
  },
  {
    name: "lang-webshop-checkout-shipping",
    path: "/:lang()/webshop/checkout/shipping",
    meta: { ...(indexUZ4JmQJF5zMmZBpc3QyElnX2ugnnP2ywiV5_dMyv7PUMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/webshop/checkout/shipping/index.vue")
  },
  {
    name: "lang-account-memberships-id-details",
    path: "/:lang()/account/memberships/:id()/details",
    meta: { ...(detailsH86G2AUup_04KDTxyP1ph6P8DHFJ5JG6c_p_hQV4XgEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/[id]/details.vue")
  },
  {
    name: "lang-open-payment-paymentId-pending",
    path: "/:lang()/open-payment/:paymentId()/pending",
    meta: pendingKOcJNrJFHpeQc9RgH1vWVyUXBC5y9BNgo69GhyQLrqIMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/open-payment/[paymentId]/pending.vue")
  },
  {
    name: "lang-open-payment-paymentId-success",
    path: "/:lang()/open-payment/:paymentId()/success",
    meta: successAHblvuhJKQ9j0XqcNcmy7wrJeXSB_nCueaT9Ki60A4YMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/open-payment/[paymentId]/success.vue")
  },
  {
    name: "WomenSignupOnePagerChooseDesign",
    path: "/:lang()/women/signup/choose-design",
    meta: indexu9d4AeaWSfUuK_E2FKmMGY3ZYEWAP7zxS5AWhd2zULEMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/choose-design/index.vue")
  },
  {
    name: "lang-account-personal-details-password",
    path: "/:lang()/account/personal-details/password",
    meta: { ...(passwordxPbinONiHIKbBS_t2OrOpJJjIahabqxjwklGA6bqCngMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/password.vue")
  },
  {
    name: "lang-women-signup-create-account",
    path: "/:lang()/women/signup/create-account",
    meta: indexRNlP1DaQ6yiBxHPYoh0U3eHLQNpENZ5SmAr_YfSEH20Meta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/create-account/index.vue")
  },
  {
    name: "lang-men-customer-service-topic",
    path: "/:lang()/men/customer-service/:topic()",
    meta: { ...(index_idubwgSKXA2HsNOemsnT5k68hShmaoGvGXljsNCm0IMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/men/customer-service/[topic]/index.vue")
  },
  {
    name: "lang-account-memberships-id-ad-details",
    path: "/:lang()/account/memberships/:id()/ad-details",
    meta: { ...(ad_45detailsg1W1MlBt2UYs3_emcQfoHdZb8jEa_W39Eh6xP_bcWz8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/[id]/ad-details.vue")
  },
  {
    name: "lang-customer-service-pause-cancel",
    path: "/:lang()/customer-service/pause-cancel",
    meta: indexuMu3I35nlEHV03FJpCybAbLL_YEmSuKAc8gvdPGMRrMMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/customer-service/pause-cancel/index.vue")
  },
  {
    name: "lang-account-memberships-id-reactivated",
    path: "/:lang()/account/memberships/:id()/reactivated",
    meta: { ...(reactivatedAFgkfwEysBqP3D01qV76rcs2kZih__2YFL34PaEUDAwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/[id]/reactivated.vue")
  },
  {
    name: "lang-account-orders-id-return-orderId",
    path: "/:lang()/account/orders/:id()/return/:orderId()",
    meta: { ...(_91orderId_937wCLe3U7XaafK1bY_dyTZm0O4w2cFBDYnQXrZh5Q_pgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/orders/[id]/return/[orderId].vue")
  },
  {
    name: "lang-delete-request-deleted-success",
    path: "/:lang()/delete-request-deleted-success",
    meta: indexkUgz6udFG66O1una4_DFYc9Fyqg9PUT3CB9A58MJKW4Meta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/delete-request-deleted-success/index.vue")
  },
  {
    name: "lang-women-customer-service-topic",
    path: "/:lang()/women/customer-service/:topic()",
    meta: { ...(indexcKbqfnGnXRcNRtkd9TL8Pu5kO6H2UjArqYL2n0k8V1UMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/customer-service/[topic]/index.vue")
  },
  {
    name: "lang-account-memberships-id-boxer-shorts",
    path: "/:lang()/account/memberships/:id()/boxer-shorts",
    meta: { ...(boxer_45shorts1pbCuqaUCyQg8E5gtukSsCcOZHbEnGuXd3Ipe7qNCt4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/[id]/boxer-shorts.vue")
  },
  {
    name: "lang-account-personal-details-contact-info",
    path: "/:lang()/account/personal-details/contact-info",
    meta: { ...(contact_45infoSA6KHwNhJl6DnWh2_Eb_hTOM2TBAiyJW27xh_x0fsEkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/contact-info.vue")
  },
  {
    name: "lang-account-personal-details-personal-info",
    path: "/:lang()/account/personal-details/personal-info",
    meta: { ...(personal_45infowulrEwvsWTlLRIamgpiVTj5pt50lpzIGM1dk4yBzn1oMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/personal-info.vue")
  },
  {
    name: "lang-account-request-personal-details",
    path: "/:lang()/account/request-personal-details",
    meta: indexUyBGseySDPH8aqOPNNi6Lz4fCbfZrjQm_nd1ncpDhegMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/request-personal-details/index.vue")
  },
  {
    name: "lang-account-personal-details-security",
    path: "/:lang()/account/personal-details/security",
    meta: { ...(indexhrP_Cw_7MelHr30xD8H0CZexWSSZXfo8KhBlmohoCBwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/security/index.vue")
  },
  {
    name: "WomenSignupOnePagerWithDesignChoice",
    path: "/:lang()/women/signup/:bralette()/:hipster()",
    meta: indexGT1n3hoEqbGU6THHl_aYBm_JLRlxJ_jF_xQyPcisb3AMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/[bralette]/[hipster]/index.vue")
  },
  {
    name: "lang-account-personal-details-payment-details",
    path: "/:lang()/account/personal-details/payment-details",
    meta: { ...(payment_45detailsb78brCaBhFJTIS_iHukwaRqBEOUwOiC5lxiX7mWEytoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/payment-details.vue")
  },
  {
    name: "lang-account-memberships-overview-member",
    path: "/:lang()/account/memberships/overview/member",
    meta: { ...(indexRq0oZ_fHIZbmcizLeoi_n5SnTV1O2XQXfiTQRFvNlKcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/overview/member/index.vue")
  },
  {
    name: "lang-account-memberships-overview-status",
    path: "/:lang()/account/memberships/overview/status",
    meta: { ...(indexftJqd6l4KQI72qfORW_nfvv2y65Mm4szO8d1Br_nEpQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/overview/status/index.vue")
  },
  {
    name: "lang-account-memberships-overview-address",
    path: "/:lang()/account/memberships/overview/address",
    meta: { ...(indexPWqCIOHFamLMKVbgeb_aNbk9go4NLpbPxdPVb9noZpsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/overview/address/index.vue")
  },
  {
    name: "MenOriginalsSignupOnePagerFixedDesign",
    path: "/:lang()/men/signup/:membershipType()/:design()",
    meta: indexn01V1rGZBBQv_czTrLONLBiA4rAG8WEIv_a8PaLV_aoMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/[membershipType]/[design]/index.vue")
  },
  {
    name: "lang-webshop-checkout-payment-confirmation",
    path: "/:lang()/webshop/checkout/payment/confirmation",
    meta: { ...(indexA0ml4b8wt6XaYPdAUch7S3IOfZEN5cl_ArLVDc6QjQoMeta || {}), ...{"middleware":["homepage"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/webshop/checkout/payment/confirmation/index.vue")
  },
  {
    name: "lang-account-memberships-overview-boxershorts",
    path: "/:lang()/account/memberships/overview/boxershorts",
    meta: { ...(index0agOwDzfMf73y0Ud9JL6JSPCv89f3rhw3XVe_EDtmZ8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/overview/boxershorts/index.vue")
  },
  {
    name: "lang-account-memberships-id-cancel-membership",
    path: "/:lang()/account/memberships/:id()/cancel-membership",
    meta: { ...(indexww70SSxYl__cn0V9_kfKhcUkKSJAMyVie4Sp_3jKyn0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/memberships/[id]/cancel-membership/index.vue")
  },
  {
    name: "lang-explore-memberships-membershipTypeReference",
    path: "/:lang()/explore-memberships/:membershipTypeReference()",
    meta: indexrDeMNONq2wnXuIMFx8L9EEWUhIRYPYAWnguUwrqmOdoMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/explore-memberships/[membershipTypeReference]/index.vue")
  },
  {
    name: "lang-account-personal-details-security-data-request",
    path: "/:lang()/account/personal-details/security/data-request",
    meta: { ...(indexkQTpXs9Rm9YzaPLk1SLQfegyBsU64sIZQWDXOZ6Iyb8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/security/data-request/index.vue")
  },
  {
    name: "lang-men-signup-create-account-verification-payment",
    path: "/:lang()/men/signup/create-account/verification-payment",
    meta: indexnz9zHLNAZUCJz9eFMyQxzeLaUcf352Z7u1CVjwvQYDkMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/create-account/verification-payment/index.vue")
  },
  {
    name: "lang-women-signup-create-account-verification-payment",
    path: "/:lang()/women/signup/create-account/verification-payment",
    meta: indexyktmVsfpgOREbjw9BnrrkYH99ARUw5aLQiKV81h9LZsMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/create-account/verification-payment/index.vue")
  },
  {
    name: "lang-women-signup-create-account-verification-payment-failed",
    path: "/:lang()/women/signup/create-account/verification-payment/failed",
    meta: failed3dKO_RhJJUps78txNOOsYIS_MSw_FWX_RFqkKfiHl7oMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/create-account/verification-payment/failed.vue")
  },
  {
    name: "lang-account-personal-details-security-deletion-request",
    path: "/:lang()/account/personal-details/security/deletion-request",
    meta: { ...(index__AVWi4NOCyIl_BfGw2RJnPDvzlC4Qk0AAcV16j1ss4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/account/personal-details/security/deletion-request/index.vue")
  },
  {
    name: "lang-women-signup-create-account-verification-payment-pending",
    path: "/:lang()/women/signup/create-account/verification-payment/pending",
    meta: pendingLnxREaFTXh3i0357t3dOx8UuLjG47Kn8uipGaafEjAEMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/create-account/verification-payment/pending.vue")
  },
  {
    name: "lang-women-signup-create-account-verification-payment-success",
    path: "/:lang()/women/signup/create-account/verification-payment/success",
    meta: successbjzQBOYo2bFHTSQow_nHMtaJfCR5BH5wtURAbHLCmEAMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/create-account/verification-payment/success.vue")
  },
  {
    name: "lang-women-signup-create-account-verification-payment-declined",
    path: "/:lang()/women/signup/create-account/verification-payment/declined",
    meta: declined_dmH2_Zy75HsyvUtoJzWeOQYgJljhvNFSCZ_fJzvYjwMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/women/signup/create-account/verification-payment/declined.vue")
  },
  {
    name: "lang-men-signup-create-account-verification-payment-failed",
    path: "/:lang()/men/signup/create-account/verification-payment/failed",
    meta: indexKs0vhX44ExyNItnh4NYCh2Qq8r0k5GBzc_XEv8Q_NU8Meta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/create-account/verification-payment/failed/index.vue")
  },
  {
    name: "lang-men-signup-create-account-verification-payment-pending",
    path: "/:lang()/men/signup/create-account/verification-payment/pending",
    meta: indexH6uYE5iYV_mULgQpJduPuiypauO0_ScTDoRNwp26P_YMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/create-account/verification-payment/pending/index.vue")
  },
  {
    name: "lang-men-signup-create-account-verification-payment-success",
    path: "/:lang()/men/signup/create-account/verification-payment/success",
    meta: index9eI_JdZVCXgzkp81VtznMQ8zGq8T1Fw1mH_hAgnFiS4Meta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/create-account/verification-payment/success/index.vue")
  },
  {
    name: "lang-men-signup-create-account-verification-payment-declined",
    path: "/:lang()/men/signup/create-account/verification-payment/declined",
    meta: indexW9jY765KYpwodyp9hBRCUCvCYBUGnYuwQvP3bprQ4fYMeta || {},
    component: () => import("/builds/on-that-ass/Frontend/app/pages/[lang]/men/signup/create-account/verification-payment/declined/index.vue")
  }
]